<template>
  <div v-if="isVisible || isInline" :class="isInline ? 'inline-container' : 'modal-overlay'" @click="isInline ? null : closeModal">
    <div :class="isInline ? 'inline-content' : 'modal-container'" @click.stop>
      <div class="modal-header">
        <button class="close-button" @click="closeModal">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      
      <div class="modal-content">
        <div class="icon-container">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="url(#gradient)" stroke-width="2"/>
            <path d="M12 6v6l4 2" stroke="url(#gradient)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <defs>
              <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#10B981"/>
                <stop offset="100%" style="stop-color:#059669"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
        
        <h2 class="modal-title">Coming Soon!</h2>
        <p class="modal-description">
          We're working hard to bring you this amazing feature. 
          Stay tuned for updates!
        </p>
        
        <button class="cta-button" @click="closeModal">
          Got it!
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComingSoonModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  methods: {
    closeModal() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-container {
  background: #ccfbf1;
  border-radius: 24px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  max-width: 480px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  display: flex;
  justify-content: flex-end;
  padding: 20px 20px 0;
}

.close-button {
  background: none;
  border: none;
  color: #6B7280;
  cursor: pointer;
  padding: 8px;
  border-radius: 12px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-button:hover {
  background: #F3F4F6;
  color: #374151;
}

.modal-content {
  padding: 0 40px 40px;
  text-align: center;
}

.icon-container {
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}

.modal-title {
  font-size: 32px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 16px;
  background: linear-gradient(135deg, #10B981, #059669);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.modal-description {
  font-size: 18px;
  color: #6B7280;
  line-height: 1.6;
  margin: 0 0 32px;
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #f0fdfa;
  border-radius: 12px;
  text-align: left;
}

.feature-icon {
  font-size: 20px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ccfbf1;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.feature-item span {
  font-weight: 500;
  color: #374151;
}

.cta-button {
  background: linear-gradient(135deg, #10B981, #059669);
  color: white;
  border: none;
  padding: 16px 32px;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  width: 100%;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.4);
}

.cta-button:active {
  transform: translateY(0);
}

/* Mobile Responsive */
@media (max-width: 640px) {
  .modal-overlay {
    padding: 16px;
  }
  
  .modal-container {
    border-radius: 20px;
  }
  
  .modal-content {
    padding: 0 24px 32px;
  }
  
  .modal-title {
    font-size: 28px;
  }
  
  .modal-description {
    font-size: 16px;
  }
  
  .feature-list {
    gap: 12px;
  }
  
  .feature-item {
    padding: 10px 12px;
  }
}
</style>
